module.exports = __webpack_public_path__ + "static/ktug-62960f91d015e80df5021f629341dc24.jpg";